module.exports = __webpack_public_path__ + "img/imagem_conecta_suite.6924da47.jpg";